import { useRequest } from 'ahooks'
import { useState } from 'react'
import { Modal, SubmitButton, Field, EyeButton } from '~components'
import Checkbox from '~components/dumbs/Checkbox'
import Subtitle from '~components/dumbs/Subtitle'
import Title from '~components/dumbs/Title'
import { useStore, usePathValidation, useNavigate } from '~hooks'
import { Auth } from '~services'
import { string, object, boolean } from '~utils/validation'
import { Values, Response } from './interfaces'
import * as Styled from './styled'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import axios, { AxiosError } from 'axios'
import { urlHandler } from '~utils/path'
import { track } from '@amplitude/analytics-browser'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

function Password() {
  // Zendesk status
  const [zd] = useSearchParams()

  const modalButton = {
    onClick: handleClickPrimaryButton,
    text: 'WhatsApp',
    forWhatsApp: true,
  }

  const defaultValues = {
    password: '',
    remember: false,
  }
  const schema = object({
    password: string(),
    remember: boolean(),
  })
  const { loading, runAsync } = useRequest(Auth.login, { manual: true })
  const [isPasswordVisible, setPasswordVisible] = useState(false)
  const store = useStore()
  const message = `Olá, preciso de ajuda para acessar a minha conta com o CPF ${store.cpf}. Poderia me ajudar?`
  const navigate = useNavigate()
  const [openModal, setOpenModal] = useState(false)
  const {
    handleSubmit,
    formState: { errors, isValid, isDirty },
    register,
    setError,
    setFocus,
  } = useForm({
    defaultValues,
    mode: 'onSubmit',
    resolver: yupResolver(schema),
  })

  useEffect(() => {
    track('login_senha')
  }, [])

  usePathValidation(['cpf'])

  function handleClickPrimaryButton() {
    window.open(`https://wa.me/551141181843/?text=${encodeURI(message)}`)
  }
  function handleClickShowPassword() {
    setFocus('password')
    setPasswordVisible((prevState) => !prevState)
  }
  function handleClickForgotPassword() {
    track('ignito__recuperacao_de_senha__digite_sua_senha__esqueci_a_senha')
    navigate('/recuperar-senha-motorista', { state: { previousPath: '/entrar/senha' } })
  }
  function handleClickNeedHelp() {
    setOpenModal(true)
  }
  function handleClickCloseModal() {
    setOpenModal(false)
  }
  const threatmetrix_id = localStorage.getItem('threatmetrix_id')

  async function onSubmit(values: Values) {
    const url = `${process.env.REACT_APP_FRETEBRAS_SITE}/fretes`
    try {
      const response: Response = await runAsync({
        username: store.cpf,
        password: values.password,
        remember: values.remember,
        threatmetrix_id: threatmetrix_id,
        zd: zd.get('zd') ? true : false,
      })

      if (response?.redirect_to) {
        window.location.href = response?.redirect_to
      } else {
        zd.get('zd')
          ? (window.location.href = `${process.env.REACT_APP_ZENDESK_URL}/access/jwt?jwt=${response?.zendesk?.sso_token}&return_to=${response?.zendesk?.trucker_hc}`)
          : (window.location.href = urlHandler(url))
      }

      track('login_sucesso')
    } catch (error) {
      console.error(error)
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError<{
          message: string
        }>

        if (axiosError.response.data.message === 'Too Many Attempts.') {
          navigate('/entrar/dificuldade', { state: { previousPath: '/entrar/senha' } })
        }
      }
      setError('password', { type: 'manual', message: 'Senha incorreta.' })
    }
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} aria-labelledby="form-password-title">
        <Title id="form-password-title">Que bom que você voltou!</Title>
        <Subtitle>Digite sua senha.</Subtitle>
        <Field
          data-testid="password"
          name="password"
          label="Senha"
          type={isPasswordVisible ? 'text' : 'password'}
          icon={
            <EyeButton onClick={handleClickShowPassword} visibility={isPasswordVisible} />
          }
          isValid={isValid}
          register={register}
          error={errors.password}
          key="password"
          maxLength={72}
        />
        <Checkbox register={register} label="Me manter conectado" name="remember" />
        <SubmitButton
          width="100%"
          loading={loading}
          key="submit-button"
          disabled={!isDirty}
        >
          Entrar
        </SubmitButton>
        <Styled.LinkButton
          type="button"
          width="100%"
          color="tertiary"
          onClick={handleClickForgotPassword}
        >
          Esqueci a senha
        </Styled.LinkButton>
        <Styled.LinkButton
          type="button"
          width="100%"
          color="subtle"
          onClick={handleClickNeedHelp}
        >
          Preciso de ajuda
        </Styled.LinkButton>
      </form>
      <Modal
        open={openModal}
        onClose={handleClickCloseModal}
        title="Está com dificuldades para acessar a Fretebras?"
        message="Entre em contato que nós vamos te ajudar."
        buttons={{ primary: modalButton }}
      />
    </>
  )
}

export default Password
